import { cn } from '@/lib/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { DropzoneState } from 'react-dropzone';

export const DropContainer: FC<PropsWithChildren<DropzoneState & { message: ReactNode }>> = ({
  children,
  getRootProps,
  getInputProps,
  isDragActive,
  message
}) => {
  return (
    <div
      id="drop-container"
      className={cn('w-full flex flex-col transition-colors flex-1 h-full', isDragActive && 'bg-[#fafaff]')}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <AnimatePresence>
        {isDragActive && (
          <motion.div
            initial={{ height: 0, marginBottom: 0 }}
            animate={{ height: 'auto', marginBottom: 16 }}
            exit={{ height: 0, marginBottom: 0 }}
            className="overflow-clip"
          >
            <div
              className={cn(
                'w-full py-3 bg-primary-50 text-primary-500 font-medium flex justify-center items-center px-4'
              )}
            >
              {isDragActive && <p>{message}</p>}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {children}
    </div>
  );
};
